export type tagsCoursesDataType = {
  name: string;
  id: string;
  certificateCount: number;
  tags: string[];
};

export const tagsCoursesDataContent = [
  {
    name: 'Administração',
    id: 'cl62afzdjew3v0ck3epscx10c',
    certificateCount: 16,
    tags: [
      'Administração Tributária',
      'Governança Estratégica',
      'Business Intelligence',
      'Gerenciamento de Projetos',
      'Negócios Internacionais',
      'Planejamento Financeiro',
      'Empreendedorismo',
      'Contabilidade',
      'Análise de Demonstrações Financeiras',
      'M&A - Fusões e Aquisições',
    ],
  },
  {
    name: 'Análise e Desenvolvimento de Sistemas',
    id: 'cl62ag3uwewj60ck3wa5qu88f',
    certificateCount: 10,
    tags: [
      'Frontend',
      'Backend',
      'UX - Experiência do Usuário',
      'Estruturas de Dados',
      'Modelagem de Bancos de Dados',
      'Cloud Computing',
      'Devops',
      'Lógica de Programação',
      'Design de Software',
      'Desenvolvimento Mobile',
    ],
  },
  {
    name: 'Ciência da Computação',
    id: 'cl62agjsxewy60ck3gdvp4u46',
    certificateCount: 16,
    tags: [
      'Frontend',
      'Backend',
      'Desenvolvimento Mobile',
      'Algoritmos',
      'Engenharia de Software',
      'Computação Gráfica',
      'Lógica de Programação',
      'Modelagem de Bancos de Dados',
      'Machine Learning',
      'Redes Neurais',
    ],
  },
  {
    name: 'Ciência de Dados',
    id: 'cl62agmyycybl0ck6krpsmdsm',
    certificateCount: 10,
    tags: [
      'Arquitetura de computadores',
      'Probabilidade e Estatística',
      'Coleta e Tratamento de Dados',
      'Desenvolvimento de Algoritmos',
      'CyberSecurity',
      'Ciência de Dados para Negócios',
      'Big Data',
      'Redes Neurais e Deep Learning',
      'Clusterização de dados',
      'Modelagem de Dados',
    ],
  },
  {
    name: 'Engenharia da Computação',
    id: 'cl62aghpz62qa0bk2l54vyatz',
    certificateCount: 16,
    tags: [
      'Frontend',
      'Backend',
      'UX - Experiência do Usuário',
      'Inteligência Artificial',
      'Modelagem de Bancos de Dados',
      'Cloud Computing',
      'Redes de Computadores',
      'Computação Gráfica',
      'Cibersegurança',
      'Desenvolvimento Mobile',
    ],
  },
  {
    name: 'Engenharia de Software',
    id: 'cln99sqssdj8y0bkbm4lf7ohd',
    certificateCount: 16,
    tags: [
      'Frontend',
      'Backend',
      'UX - Experiência do Usuário',
      'Inteligência Artificial',
      'Modelagem de Bancos de Dados',
      'Cloud Computing',
      'Redes de Computadores',
      'Computação Gráfica',
      'Cibersegurança',
      'Desenvolvimento Mobile',
    ],
  },
  {
    name: 'Gestão Financeira',
    id: 'cl62agfq1cy170ck6sh178zsi',
    certificateCount: 8,
    tags: [
      'Modelos de Gestão',
      'Matemática Financeira',
      'Finanças Corporativas',
      'Mercados Financeiros',
      'Legislação Societária e Tributária',
      'Análise de Demonstrações Financeiras',
      'Valuation',
      'Governança Estratégica Corporativa',
      'M&A - Fusões e Aquisições',
      'Direito Empresarial',
    ],
  },
  {
    name: 'Gestão de Recursos Humanos',
    id: 'cl62ag10fd42c0ckc6ir57mi6',
    certificateCount: 8,
    tags: [
      'Formação de Líderes',
      'Gestão de Benefícios',
      'Avaliação de Desempenho',
      'Gestão de Pessoas e Equipes',
      'Carreiras e Remuneração',
      'Treinamento e Desenvolvimento',
      'Direito Trabalhista e Previdenciário',
      'Recrutamento e Seleção',
      'Consultoria de RH',
      'Desenvolvimento Organizacional',
    ],
  },
  {
    name: 'Marketing',
    id: 'cl62agdqr62ot0bk2r8kz3m6p',
    certificateCount: 8,
    tags: [
      'Planejamento Estratégico',
      'Gerenciamento de Projetos',
      'Neuromarketing',
      'Conceitos e Práticas de Marketing',
      'Empreendedorismo',
      'Criação de Novos Negócios',
      'Comércio Eletrônico',
      'Custos e Formação de Preços',
      'Business Intelligence',
      'Pesquisa de Mercado',
    ],
  },
  {
    name: 'Marketing Digital',
    id: 'cl62agmbkd53w0ckcm1q75u1w',
    certificateCount: 8,
    tags: [
      'Redes Sociais',
      'Marketing Digital',
      'Product e Market Growth',
      'Retenção e Engajamento',
      'Relacionamento com Clientes',
      'Martech',
      'Gerenciamento de Projetos',
      'Marketing Analytics e Adwords',
      'Inbound e Outbound Marketing',
      'Jornada do consumidor',
    ],
  },
  {
    name: 'Sistemas de Informação',
    id: 'cl62ag8bsews60ck34ccfm16x',
    certificateCount: 16,
    tags: [
      'Programação Extrema',
      'Design de Software',
      'Arquitetura de Computadores',
      'Inteligência Artificial',
      'Big Data',
      'Desenvolvimento na Nuvem',
      'Desenvolvimento de Software',
      'Estruturas de Dados',
      'Redes de computadores',
      'Cibersegurança',
    ],
  },
  {
    name: 'Engenharia da Fera', // course for tests (staging)
    id: 'cktvwdedse6wy0b232moikt4m',
    certificateCount: 10,
    tags: [
      'Fera no Código',
      'Fera Tech',
      'Rugido de Programação',
      'Domando Bits',
      'Algoritmos Selvagens',
      'Código na Selva',
      'Sistemas Feraçados',
      'Fera de Software',
      'Codando Feras',
      'Data Fera',
      'Fera hardworking',
    ],
  },
];
